import { GiocaScopa } from './GiocaScopa';
import { TavoliMieiScopa } from './TavoliMieiScopa';
import { TorneiScopa } from './TorneiScopa';

/**
 * La Hub della scopa (sul modello della Hub del Burraco, `components/burraco/HubBurraco.tsx`): col gioco attivo = Scopa la Hub non ha la riga delle sezioni, ha TRE
 * blocchi — «Gioca» (scopa o scopone; Gioca, Invita un amico, Entra con un codice), «I miei tavoli / Riprendi» e i tornei del gioco (`TorneiScopa`, S7) — dentro UN solo scorrevole.
 * La classifica e la scheda «Ranked» (la coda) sono fuori da qui: non c'e un disegno. La stessa Hub e la pagina `/scopa` (`routes/scopa/ScopaHome.tsx`).
 *
 * ⚠️ Lo montano `HubSections` e la rotta SOLO dentro il confronto LETTERALE del flag `VITE_FEATURE_SCOPA_ENABLED` (che il bundler piega): questo file e il marcatore
 * `data-hub-scopa` non sono in produzione. La serratura (`beta`, Limulo acceso) sta in `HubSections`, nel selettore e nel `RoleGate` della rotta.
 */
export function HubScopa() {
  return (
    <div data-hub-scopa className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain py-2 [touch-action:pan-y]">
      <GiocaScopa />
      <TavoliMieiScopa />
      <TorneiScopa />
    </div>
  );
}
